<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbTables',
  components: {},
}
</script>
